/**
 * Smooth scroll to homepage Planning FAQ (#planning-your-project).
 * Same-page clicks animate; cross-page loads scroll from top smoothly.
 */
(function () {
  const ANCHOR_ID = 'planning-your-project';
  const HASH = `#${ANCHOR_ID}`;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function headerOffset() {
    const header =
      document.querySelector('#shopify-section-header') ||
      document.querySelector('.section-header') ||
      document.querySelector('sticky-header') ||
      document.querySelector('header');
    if (!(header instanceof HTMLElement)) return 96;
    return Math.ceil(header.getBoundingClientRect().height) + 16;
  }

  function targetElement() {
    return document.getElementById(ANCHOR_ID);
  }

  function scrollToPlanningFaq(behavior) {
    const el = targetElement();
    if (!el) return false;

    const useSmooth = behavior === 'smooth' && !prefersReducedMotion();
    const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: useSmooth ? 'smooth' : 'auto',
    });

    return true;
  }

  function isPlanningFaqLink(anchor) {
    if (!(anchor instanceof HTMLAnchorElement)) return false;
    try {
      const url = new URL(anchor.href, window.location.href);
      return url.hash === HASH;
    } catch (e) {
      return false;
    }
  }

  function sameDocument(anchor) {
    try {
      const url = new URL(anchor.href, window.location.href);
      return url.pathname === window.location.pathname && url.search === window.location.search;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!isPlanningFaqLink(anchor) || !sameDocument(anchor)) return;
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      if (window.location.hash !== HASH) {
        history.pushState(null, '', HASH);
      }
      scrollToPlanningFaq('smooth');
    },
    true
  );

  function handleInitialHash() {
    if (window.location.hash !== HASH) return;
    if (!targetElement()) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    window.scrollTo(0, 0);

    const run = () => {
      requestAnimationFrame(() => {
        scrollToPlanningFaq(prefersReducedMotion() ? 'auto' : 'smooth');
      });
    };

    if (document.readyState === 'complete') {
      setTimeout(run, 40);
    } else {
      window.addEventListener(
        'load',
        () => {
          setTimeout(run, 40);
        },
        { once: true }
      );
    }
  }

  handleInitialHash();
})();
